export default "__VITE_ASSET__sDmOSHgx__"